import { render } from "./post_status_modal.vue?vue&type=template&id=b5c3781c"
import script from "./post_status_modal.js?vue&type=script&lang=js&external"
export * from "./post_status_modal.js?vue&type=script&lang=js&external"

import "./post_status_modal.vue?vue&type=style&index=0&id=b5c3781c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__